import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Kpi } from 'src/app/assabil-kernel/models/entities/control-tables/kpi-entity';
import { LoyaltyProgramRelease } from 'src/app/assabil-sales/models/entities/loyalty-program-release';
import { LoyaltyProgramReleaseThreshold } from 'src/app/assabil-sales/models/entities/loyalty-program-release-threshold';
import { LoyaltyService } from 'src/app/assabil-sales/services/sales-loyalty-service';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';


@Component({
    selector: 'loyalty-program-release-widget',
    templateUrl: './loyalty-program-release-widget.component.html',
    styleUrls: ['./loyalty-program-release-widget.component.scss']
})


export class LoyaltyProgramReleaseWidgetComponent extends BaseWidget {
  
  @Input() kpis : Kpi[];

  loyaltyProgramRelease            : LoyaltyProgramRelease = new LoyaltyProgramRelease();

 //---------------------------------------------------------------------------------------
  constructor(
      protected toastr               : ToastrService,
      protected leanUtilsService     : LeanUtilsService,
      protected loyaltyService       : LoyaltyService) {
      super(toastr, leanUtilsService);

      this.entityName = "loyaltyProgramRelease";
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setEntity(loyaltyProgramRelease: LoyaltyProgramRelease) {
      this.loyaltyProgramRelease  = { ...loyaltyProgramRelease };
      this.loyaltyProgramRelease.loyaltyProgramReleaseThresholds = [];
      if (loyaltyProgramRelease.loyaltyProgramReleaseThresholds) {
        for (let loyaltyProgramReleaseThreshold of loyaltyProgramRelease.loyaltyProgramReleaseThresholds) {
          this.loyaltyProgramRelease.loyaltyProgramReleaseThresholds.push({ ...loyaltyProgramReleaseThreshold });
        }
      }
    }
//---------------------------------------------------------------------------------------

  
//---------------------------------------------------------------------------------------
  getEntity(){
    return this.loyaltyProgramRelease;
  }
//---------------------------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(): Promise<LoyaltyProgramRelease> {
  return this.loyaltyService.loyaltyProgramReleaseSave(this.loyaltyProgramRelease);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
  let loyaltyProgramReleaseThreshold : LoyaltyProgramReleaseThreshold = new LoyaltyProgramReleaseThreshold();
  loyaltyProgramReleaseThreshold.inserted = true;
  loyaltyProgramReleaseThreshold.threshold	  = 0;	
  loyaltyProgramReleaseThreshold.flat	        = 0;	
  loyaltyProgramReleaseThreshold.rate	        = 0;	
  loyaltyProgramReleaseThreshold.minimum	    = 0;	
  loyaltyProgramReleaseThreshold.maximum	    = 0;	
  loyaltyProgramReleaseThreshold.vipFlat	    = 0;	
  loyaltyProgramReleaseThreshold.vipRate	    = 0;	
  loyaltyProgramReleaseThreshold.vipMminimum	= 0;	
  loyaltyProgramReleaseThreshold.vipMaximum	  = 0;	
  this.loyaltyProgramRelease.loyaltyProgramReleaseThresholds.push(loyaltyProgramReleaseThreshold);
  this.loyaltyProgramRelease.loyaltyProgramReleaseThresholds = [...this.loyaltyProgramRelease.loyaltyProgramReleaseThresholds] ;
}
//----------------------------------------------------------------------

duplicate(){
  this.loyaltyProgramRelease.inserted = true;
  this.loyaltyProgramRelease.edit = true;
  this.loyaltyProgramRelease.active   = false;
  this.loyaltyProgramRelease.startDate= null;
  this.loyaltyProgramRelease.endDate  = null;
  this.loyaltyProgramRelease.loyaltyProgramReleaseCode = null;
  if (this.loyaltyProgramRelease.loyaltyProgramReleaseThresholds) {
    for (let loyaltyProgramReleaseThreshold of this.loyaltyProgramRelease.loyaltyProgramReleaseThresholds) {
       loyaltyProgramReleaseThreshold.id        = null;
       loyaltyProgramReleaseThreshold.inserted  = true;
       loyaltyProgramReleaseThreshold.edit      = true;
    }
  }
}

}
